// extracted by mini-css-extract-plugin
export default {"container":"BlackLayout_container__0oG-5","content":"BlackLayout_content__oYY97"};